import Features from '@/utils/features';

const data = {
  persons: [
    { value: 'individual', description: 'Física' },
    { value: 'corporation', description: 'Jurídica' }
  ],
  genders: [
    { value: 'male', description: 'Masculino' },
    { value: 'female', description: 'Feminino' }
  ],
  contacts: [
    { value: 'phone', description: 'Telefone' },
    { value: 'whatsapp', description: 'Whatsapp' }
  ],
  rules: [
    { value: 'client', description: 'Cliente' },
    { value: 'partner', description: 'Parceiro' },
    { value: 'seller', description: 'Vendedor' },
    { value: 'collaborator', description: 'Colaborador' }
  ]
};

if (Features.allows('calls')) {
  data.rules.push({ value: 'doctor', description: 'Médico' });
}

export default {
  persons: _.orderBy(data.persons, [item => item.description]),
  genders: _.orderBy(data.genders, [item => item.description]),
  rules: _.orderBy(data.rules, [item => item.description]),
  contacts: data.contacts
};
